import styled from 'styled-components';

interface Props {
  active: boolean;
}

export const Container = styled.div`
  min-width: 350px;
  overflow: hidden;
  background-color: white;
  max-height: 400px;
  padding: 15px;
  overflow-y: auto;
  border-radius: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.softGray};
  background-color: ${(props) => props.theme.colors.softGray};
  border: 2px solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  margin-bottom: 10px;

  &:focus {
    background-color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.primary};
    outline: none;
  }
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Option = styled.div<Props>`
  height: 40px;
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.active && props.theme.colors.primary};
  color: ${(props) =>
    props.active ? props.theme.colors.white : props.theme.colors.darkGray};
  justify-content: flex-start;
  gap: 10px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.primaryLight};
    color: ${(props) =>
      props.active ? props.theme.colors.white : props.theme.colors.primary};
  }
  svg {
    font-size: 18px;
  }
`;
